/**
 * Kleurnamen vertalen.
 *
 * De optiewaarde zelf blijft Duits — dat is met opzet, en de reden staat in
 * snippets/cl-kleurvertaling.liquid: het kleurenpalet in de theme-instellingen
 * koppelt een náám aan een hex, dus zodra "Rot" in Shopify "Rød" wordt vindt
 * cl-swatchkleur.liquid niets meer en vallen de stalen terug op de kleur die
 * Shopify bewaart. Die heeft er maar 120 van de 195.
 *
 * Liquid vertaalt de eerste weergave al. Dit bestand bestaat omdat het thema
 * die tekst daarna zelf herschrijft: bij elke variantwissel zet het de rauwe
 * optiewaarde terug in `[data-selected-value-for-option]`. Zonder deze kijker
 * zie je dus Deens tot je een andere kleur kiest, en daarna weer Duits.
 *
 * De tabel komt uit hetzelfde taalbestand als de Liquid-kant, zodat er niet
 * twee lijsten kunnen ontstaan die uit elkaar lopen.
 */
(function () {
  'use strict';

  var bron = document.getElementById('cl-kleurtabel');
  if (!bron) return;

  var tabel = {};
  try {
    var ruw = JSON.parse(bron.textContent).tabel || '';
    ruw.split('\n').forEach(function (regel) {
      var deel = regel.split(':');
      if (deel.length < 2) return;
      var sleutel = deel[0].trim().toLowerCase();
      var waarde = deel.slice(1).join(':').trim();
      if (sleutel && waarde) tabel[sleutel] = waarde;
    });
  } catch (e) { return; }

  if (!Object.keys(tabel).length) return;   // brontaal: niets te doen

  var DOELEN = '[data-selected-value-for-option],[data-cl-kieswaarde],[data-qa-gekozen],[data-cl-variantregel]';

  function vertaal(el) {
    var nu = (el.textContent || '').trim();
    if (!nu) return;

    // De variantregel in het mandje is een samengestelde tekst ("Grau / S"),
    // niet één waarde. Liquid vertaalt hem bij het renderen al, maar het thema
    // bouwt de lade opnieuw op bij elke aantalswijziging en zet dan de rauwe
    // titel terug. Daarom hier per deel vertalen in plaats van in één keer.
    if (el.hasAttribute('data-cl-variantregel')) {
      var delen = nu.split(' / ');
      var uit = delen.map(function (d) {
        var w = d.trim();
        return tabel[w.toLowerCase()] || w;
      });
      var samen = uit.join(' / ');
      if (samen !== nu) el.textContent = samen;
      return;
    }

    var t = tabel[nu.toLowerCase()];
    // `data-cl-bron` onthoudt de rauwe waarde, zodat een tweede ronde niet de
    // vertaling nog eens probeert te vertalen.
    if (t && t !== nu) {
      el.setAttribute('data-cl-bron', nu);
      el.textContent = t;
    }
  }

  function alles(wortel) {
    var lijst = (wortel || document).querySelectorAll(DOELEN);
    for (var i = 0; i < lijst.length; i++) vertaal(lijst[i]);
  }

  alles();

  // Het thema schrijft de waarde terug bij elke variantwissel, en de snelkoop-
  // lade voegt haar inhoud later toe. Eén kijker vangt allebei.
  var bezig = false;
  var kijker = new MutationObserver(function () {
    if (bezig) return;
    bezig = true;
    requestAnimationFrame(function () { alles(); bezig = false; });
  });
  kijker.observe(document.body, { childList: true, subtree: true, characterData: true });
})();
